import React from 'react';
import classes from '../InviteUsersModal.module.scss';
import { Button, FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';

type FooterButtonsProps = {
  currentSection: string;
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
  onFinish: () => Promise<void>;
  form: FormInstance<any>;
  linkForm: FormInstance<any>;
  onCancel: () => Promise<void>;
  globalEmails: string[];
  newEmails: string[];
  emailIsValid: boolean;
};

const FooterButtons = ({
  currentSection, setCurrentSection, onFinish, form, linkForm, onCancel, globalEmails, newEmails, emailIsValid
}: FooterButtonsProps) => {
  const { t } = useTranslation();
  
  const depricatedSendInvites = () => {
    if (!globalEmails.length && !newEmails.length && !emailIsValid) return true;
    else return false;
  }
  
  return (
    <div className={classes.footerWrapper}>
      <div className={classes.footerButtons}>
        {(currentSection === 'newRole' || currentSection === 'users' || currentSection === 'createLink') &&
          <Button onClick={() => setCurrentSection(currentSection === 'createLink' ? 'users' : 'roles')}>
            {t('Users.modals.invite.back')}
          </Button>
        }

        {currentSection === 'roles' && (
          <Button
            type='primary'
            onClick={() => setCurrentSection('users')}
          >
            {t('Users.modals.invite.continue')}
          </Button>
        )}

        {currentSection === 'users' && (
          <Button
            onClick={onFinish}
            disabled={depricatedSendInvites()}
            type='primary'
          >
            {t('Users.modals.invite.submitText')}
          </Button>
        )}

        {(currentSection === 'links') &&
          <Button onClick={onCancel}>
            {t('main.closeButton')}
          </Button>
        }

        {currentSection === 'newRole' && (
          <Button
            type='primary'
            onClick={form.submit}
          >
            {t('Users.modals.configureRoles.create')}
          </Button>
        )}

        {currentSection === 'createLink' && (
          <Button
            type='primary'
            onClick={linkForm.submit}
          >
            {t('Users.modals.invite.createLink')}
          </Button>
        )}
      </div>

      {currentSection === 'users' && (
        <Button
          type='primary'
          className={classes.createLinkButton}
          onClick={() => setCurrentSection('createLink')}
        >
          {t('Users.modals.invite.createLink')}
        </Button>
      )}
    </div>
  );
}

export default FooterButtons;
